export const STATUS_DONE = 'done';
export const STATUS_UNDONE = 'undone';
export const STATUS_VERIFICATION = 'verification';

export const CARE_OPERATOR_ROLE = 'care_operator';
export const CARE_VERIFICATOR_ROLE = 'care_verificator';

export const TYPE_COMPLAINT = 'complaint';
export const TYPE_ASPIRATION = 'aspiration';
export const TYPE_INFORMATION_REQUEST = 'information_request';

/* Status Select Option List */
export const SELECT_OPTION_STATUS_LIST = [
  {
    id: null,
    label: 'Semua Status'
  },
  {
    id: STATUS_DONE,
    label: 'Selesai'
  },
  {
    id: STATUS_UNDONE,
    label: 'Belum Ditindaklanjuti'
  },
  {
    id: STATUS_VERIFICATION,
    label: 'Proses Verifikasi'
  },
];

/* Type Select Option List */
export const SELECT_OPTION_TYPE_LIST = [
  {
    id: null,
    label: 'Semua Tipe'
  },
  {
    id: TYPE_COMPLAINT,
    label: 'Komplain'
  },
  {
    id: TYPE_ASPIRATION,
    label: 'Aspirasi'
  },
  {
    id: TYPE_INFORMATION_REQUEST,
    label: 'Permohonan Informasi'
  },
];